export const USER_LOGIN_SUCCESSFUL = 'user.USER_LOGIN_SUCCESSFUL';
export const USER_LOGIN_ERROR = 'user.USER_LOGIN_ERROR';
export const USER_LOGIN_CLEAR = 'user.USER_LOGIN_CLEAR';
export const USER_LOGOUT = 'user.USER_LOGOUT';
export const CHANGEPASSWORD_INIT = 'user.CHANGEPASSWORD_INIT';

export const FETCH_SUBSCRIPTIONS_SUCCESSFUL =
  'partner.FETCH_SUBSCRIPTIONS_SUCCESSFUL';
export const FETCH_SUBSCRIPTIONS_ERROR = 'partner.FETCH_SUBSCRIPTIONS_ERROR';
